import { render, staticRenderFns } from "./ScorecardDetails.vue?vue&type=template&id=2f86d6bb&scoped=true&"
import script from "./ScorecardDetails.vue?vue&type=script&lang=ts&"
export * from "./ScorecardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ScorecardDetails.vue?vue&type=style&index=0&id=2f86d6bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86d6bb",
  null
  
)

export default component.exports